import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgErrorOutlined = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 12,
			r: 9,
			stroke: "#F10404",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13 17H11V15H13V17Z",
			fill: "#F10404"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 7C12.55 7 13 7.45 13 8V12C13 12.55 12.55 13 12 13C11.45 13 11 12.55 11 12V8C11 7.45 11.45 7 12 7Z",
			fill: "#F10404"
		})
	]
});
export default SvgErrorOutlined;
